import { useState } from 'react';
import { api } from '../cloud/api';

interface Props {
    onSent?: () => void;
}

type FormState = 'idle' | 'sending' | 'sent' | 'error';

export function MagicLinkForm({ onSent }: Props) {
    const [email, setEmail] = useState('');
    const [state, setState] = useState<FormState>('idle');
    const [err, setErr] = useState('');

    async function submit(e: React.FormEvent) {
        e.preventDefault();
        setState('sending');
        setErr('');
        try {
            await api.authRequest(email.trim());
            setState('sent');
            onSent?.();
        } catch (ex) {
            const msg = ex instanceof Error ? ex.message : String(ex);
            setErr(msg);
            setState('error');
        }
    }

    return (
        <form onSubmit={submit} className="card mt-6 space-y-3">
            <h2 className="text-lg font-semibold">Sign in</h2>
            <p className="muted">
                We'll email you a magic link. No password needed —
                tap the link on this device to sign in.
            </p>
            <input
                type="email"
                required
                value={email}
                onChange={e => setEmail(e.currentTarget.value)}
                placeholder="you@your.tld"
                autoComplete="email"
                inputMode="email"
                className="w-full p-3 rounded-lg border border-line bg-surface-raised"
            />
            <button
                type="submit"
                disabled={state === 'sending' || state === 'sent'}
                className="btn-primary w-full"
            >
                {state === 'sending' ? 'Sending…'
                    : state === 'sent' ? 'Link sent — check your email'
                    : 'Email me a link'}
            </button>
            {state === 'sent'  && <p className="success">Check your email — link arrives in seconds.</p>}
            {state === 'error' && <p className="error">Couldn't send: {err}</p>}
        </form>
    );
}
